<template>
  <div class="apply_electronic">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_div">
          <div class="security_main_body_div_H1">舆情监控</div>
          <div class="security_main_body_div_text">
            帮助您挖掘互联网公开舆情信息，追踪用户的关注及反馈，及时了解行业热点话题和动态，实现更好的品牌互动与连接
          </div>
          <div class="security_main_body_div_butts">
            <div class="security_main_body_div_butt div_buttA" @click="loginshow">免费试用</div>
            <div class="security_main_body_div_butt div_buttB" @click="topay">产品价格</div>
          </div>
          <div class="apply_electronic_dzsw_d4">
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon3.svg"
                alt=""
              />
              <div>精准定位城市IP</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon5.svg"
                alt=""
              />
              <div>自定义代理时效</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon2.svg"
                alt=""
              />
              <div>99.9%正常运行时间</div>
            </div>
            <div>
              <img
              style="width: 60px;"
                src="http://apiupss.ppfly.top/images/banner_icon8.svg"
                alt=""
              />
              <div>7*24实时支持</div>
            </div>
          </div>
        </div>

        <div class="security_main_body_divB">
          <div class="security_main_body_divB_div">
            <div class="security_main_body_divB_div_left">
              <div>
                <div class="security_main_body_divB_div_left_H1">
                  掌握全球舆情走向
                </div>
                <div class="security_main_body_divB_div_left_text">
                  获取准确、及时的市场舆情数据，提升舆情处理效率
                </div>
              </div>
              <div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>关注客户情绪</div>
                    <div class="applyele_list_img_text">
                      监测客户评论并及时作出适当回应，引导正向的客户情绪，及时维护品牌形象
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>挖掘用户需求</div>
                    <div class="applyele_list_img_text">
                      检索主流媒体平台热点内容和焦点话题，分析客户消费习惯和流行趋势
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>安全防控</div>
                    <div class="applyele_list_img_text">
                      实时了解全球行业动态，提高舆情处理效率，增强企业和品牌风险防范能力
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="security_main_body_divB_div_reft">
              <img
                src="http://apiupss.ppfly.top/images/introduce_r_10.svg"
                alt=""
              />
            </div>
          </div>
        </div>

        <apply_electronic_mainket />
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>
<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
import apply_electronic_mainket from "@/components/apply_electronic_mainket/apply_electronic_mainket.vue";
export default {
  // apply-market
  name: "apply_opinion",
  components: {
    Head,
    Footer,
    Xuanfuret,
    apply_electronic_mainket,
  },
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    topay(){
      this.$router
          .push({
            path: "/pay",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
    },
    loginshow() {
      const token = this.$cookies.get("userdata");
      if (token == null) {
        this.$router
          .push({
            path: "/userlogin",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
      }
    },
  },

  created() {

  },
  mounted() {
    this.totop()
  },
};
</script>
<style lang="scss" scoped>
.security_main_body{
  background-color: #f5f2f23a;
}
.security_main_body_div {
  background: url(http://apiupss.ppfly.top/images/buy-banner.bb39d3b.png);
  background-color: #edf3fc;
  background-repeat: no-repeat;
  padding-bottom: 50px;
  // https://oss.kookeey.com/keekooy-next-dist/public/_nuxt/proxy-network_bg.1d9685a0.png
}
.security_main_body_div_H1 {
  padding-top: 80px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 54px;
  color: #1b2336;
  line-height: 76px;
}
.security_main_body_div_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 22px;
  color: rgba(18, 17, 39, 0.72);
  line-height: 40px;
  max-width: 865px;
  margin: 31px auto 0;
}
.apply_electronic_dzsw_d4 {
  width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.apply_electronic_dzsw_d4  img{
  margin-bottom: 30px;
}
.security_main_body_div_butts {
  display: flex;
  justify-content: center;
  margin: 80px 0 80px 0;
}

.security_main_body_div_butt {
  width: 191px;
  height: 54px;
  border-radius: 45px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  cursor: pointer;
  box-sizing: border-box;
}
.div_buttA {
  background: #3580ff;
  color: #edf3fc;
}
.div_buttB {
  background: transparent;
  border: 1px solid #0e1d3c;
  color: #0e1d3c;
}
.security_main_body_divB {
  margin-top: 200px;
}
.security_main_body_divB_div {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 60px;
  background-color: #edf3fc;
  border-radius: 10px;
}
.security_main_body_divB_div_left {
  width: 50%;
  padding-top: 75px;
}
.security_main_body_divB_div_reft {
  width: 50%;
  margin-top: 60px;
}
.security_main_body_divB_div_left_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 36px;
  color: #1b2336;
  line-height: 40px;
  text-align: left;
}
.security_main_body_divB_div_left_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #565656;
  line-height: 26px;
  margin-top: 34px;
  margin-bottom: 24px;
  text-align: left;
}
.applyele_list_img {
  display: flex;
  justify-content: left;
  margin: 10px 0 10px 0;
}
.applyele_list_img > div {
  text-align: left;
  margin-right: 20px;
}
.applyele_list_img > div:nth-child(1) {
  text-align: left;
  margin-top: 7px;
}
.applyele_list_img_text {
  font-weight: 400;
  font-size: 14px;
  color: #565656;
  margin-top: 5px;
}
</style>
